import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Divider,
  Text,
  Flex,
  Button,
} from '@chakra-ui/react';

const ConfirmModal = ({
  isOpen,
  onClose,
  icon,
  title,
  description,
  children,
  primaryButton,
  secondaryButton,
  tertiaryButton,
  textBelowButtons,
  horizontalButtons = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent py={6} px={8}>
        <ModalCloseButton />
        {icon && (
          <Flex justifyContent="center" mt="10px">
            {icon}
          </Flex>
        )}
        {title && (
          <Text
            textStyle="heading4"
            fontSize="24px"
            mt="10px"
            textAlign="center"
          >
            {title}
          </Text>
        )}
        <ModalBody>
          <Divider border="0.5px solid lightGrey" my="15px" />
          <Flex direction="column" w="100%" gap={4}>
            {description ? (
              <Text textStyle="bodyFamilyRegular" fontSize="16px">
                {description}
              </Text>
            ) : null}
            {children}
          </Flex>
        </ModalBody>
        <ModalFooter flexDirection="column" alignItems="center" gap={4}>
          <Flex
            w="100%"
            direction={horizontalButtons ? 'row' : 'column'}
            gap="15px"
            alignItems="center"
            justifyContent="center"
          >
            {horizontalButtons ? (
              <>
                {secondaryButton ? (
                  <Button
                    variant={secondaryButton.variant || 'link'}
                    size="sm"
                    onClick={secondaryButton.onClick}
                    isLoading={secondaryButton.isLoading}
                    loadingText={secondaryButton.loadingText}
                  >
                    <Text>{secondaryButton.label}</Text>
                  </Button>
                ) : null}
                {primaryButton ? (
                  <Button
                    {...primaryButton.linkProps}
                    size="md"
                    variant={primaryButton.variant || 'secondary'}
                    onClick={primaryButton.onClick}
                    isLoading={primaryButton.isLoading}
                    loadingText={primaryButton.loadingText}
                    isDisabled={primaryButton.isDisabled}
                  >
                    <Text>{primaryButton.label}</Text>
                  </Button>
                ) : null}
              </>
            ) : (
              <>
                {primaryButton ? (
                  <Button
                    {...primaryButton.linkProps}
                    variant={primaryButton.variant || 'gradient'}
                    w="100%"
                    onClick={primaryButton.onClick}
                    isLoading={primaryButton.isLoading}
                    loadingText={primaryButton.loadingText}
                    isDisabled={primaryButton.isDisabled}
                  >
                    {primaryButton.label}
                  </Button>
                ) : null}
                {secondaryButton ? (
                  <Button
                    size={secondaryButton.size || 'sm'}
                    variant={secondaryButton.variant || 'link'}
                    w={secondaryButton.w}
                    onClick={secondaryButton.onClick}
                    isLoading={secondaryButton.isLoading}
                    loadingText={secondaryButton.loadingText}
                  >
                    {secondaryButton.variant &&
                    secondaryButton.variant !== 'link' ? (
                      secondaryButton.label
                    ) : (
                      <Text>{secondaryButton.label}</Text>
                    )}
                  </Button>
                ) : null}
                {tertiaryButton ? (
                  <Button
                    size="sm"
                    variant={tertiaryButton.variant || 'link'}
                    onClick={tertiaryButton.onClick}
                    isLoading={tertiaryButton.isLoading}
                    loadingText={tertiaryButton.loadingText}
                  >
                    <Text>{tertiaryButton.label}</Text>
                  </Button>
                ) : null}
              </>
            )}
          </Flex>

          {textBelowButtons ? (
            <Flex justifyContent="center">
              <Text textStyle="bodyFamilyRegular" fontSize="14px">
                {textBelowButtons}
              </Text>
            </Flex>
          ) : null}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
